import React from 'react';
import { connect } from 'react-redux';
import ConstCommon from '../../common/Const';
import { withSyncDragCode } from '../../common/sync-drag-code';
import {
  getCodeFromQuery,
  getQueryParams,
  removeDragCode,
  syncComponentSelector,
} from '../../helpers/Common';
import { changeCode, fetchValuationTool, REDUCER_NAME } from './reducer';
import ScrollComponent from './../../common/ScrollComponent';
import InforHeader from './InforHeader';
import FCFE from './method/FCFE';
import PE from './method/PE';
import PB from './method/PB';
import './index.scss';
import PreRender from './../../common/PreRender';
import { compose } from 'redux';
import SizeTracker from '../../common/size-tracker/SizeTracker';
import { ComponentNameProvider } from '../../common/ComponentNameContext';
import { Provider } from '../../common/ComponentIdContext';
import Loading from '../../common/loading/Loading';

class Valuation extends React.Component {
  constructor(props) {
    super(props);
    const { glContainer, changeCode } = this.props;
    removeDragCode(glContainer);
    const codeFromQuery = getCodeFromQuery(['stock']);
    if (codeFromQuery) {
      changeCode(codeFromQuery);
    }
  }

  componentDidMount() {
    const { fetchValuationTool } = this.props;
    if (!getQueryParams('code')) {
      fetchValuationTool();
    }
  }

  renderChild = (width, child) => {
    const MIN_WIDTH = 500;
    return (
      <div
        className={`valuation-tool-calculate-screen ${
          width > MIN_WIDTH ? 'd-flex' : ''
        }`}
      >
        {child}
      </div>
    );
  };

  render() {
    const { isLoading, id } = this.props;
    return (
      <PreRender {...this.props}>
        <ComponentNameProvider value={ConstCommon.listComponent.Valuation}>
          <Provider value={id}>
            <ScrollComponent>
              <div className="valuation-wrapper px-20 h-100 d-flex flex-column position-relative">
                {isLoading && <Loading />}
                <div
                  className={`${
                    isLoading ? 'bg-blur' : ''
                  } d-flex flex-column flex-fill`}
                >
                  <div className="valuation-top-content">
                    <InforHeader />
                  </div>
                  <div className="valuation-body-content d-flex flex-fill">
                    <SizeTracker className={'d-flex flex-fill'}>
                      {width => {
                        return (
                          <div className="d-flex flex-column">
                            {this.renderChild(width, <FCFE />)}
                            {this.renderChild(width, <PE />)}
                            {this.renderChild(width, <PB />)}
                          </div>
                        );
                      }}
                    </SizeTracker>
                  </div>
                </div>
              </div>
            </ScrollComponent>
          </Provider>
        </ComponentNameProvider>
      </PreRender>
    );
  }
}

const mapStateToProps = (state, { id, glContainer }) => {
  return {
    isLoading: state[REDUCER_NAME].isLoading,
    syncType: syncComponentSelector(
      state,
      ConstCommon.listComponent.Valuation,
      id,
    ),
  };
};

const mapDispatchToProps = {
  fetchValuationTool,
  changeCode,
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withSyncDragCode,
)(Valuation);
